var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Close_Filled",
    "data-name": "Icon Close Filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.41 13.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#70a53c;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    className: "cls-1",
    d: "M18.7,7,17,5.3l-5,5-5-5L5.3,7l5,5-5,5L7,18.7l5-5,5,5L18.7,17l-5-5Z",
    transform: "translate(-5.3 -5.3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/Icon_Close.cfe46b1c166459ba101d43ca684e6e94.svg";
export { ForwardRef as ReactComponent };